function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HudLayer = require('../hud-layer');
var ThesesTemplate = require('./theses.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var ThesesOverlay = /*#__PURE__*/function () {
  function ThesesOverlay(app, mod) {
    _classCallCheck(this, ThesesOverlay);
    this.app = app;
    this.mod = mod;
    this.visible = false;
    this.overlay = new SaitoOverlay(app, mod);
    this.rendering_at_coordinates = false;
    this.spaces_onclick_callback = null;
  }
  return _createClass(ThesesOverlay, [{
    key: "pullHudOverOverlay",
    value: function pullHudOverOverlay() {
      HudLayer.pullHudOverOverlay.call(this);
    }
  }, {
    key: "pushHudUnderOverlay",
    value: function pushHudUnderOverlay() {
      HudLayer.pushHudUnderOverlay.call(this);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.visible = false;
      this.overlay.remove();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.visible = false;
      this.overlay.hide();
    }
  }, {
    key: "renderAtSpacekey",
    value: function renderAtSpacekey(spacekey) {
      var left = 0;
      var top = 0;
      var board_height = 0;
      var board_width = 0;
      var element = document.querySelector(".".concat(spacekey));
      if (element) {
        var rect = element.getBoundingClientRect();
        top = rect.top;
        left = rect.left;
      }
      var coords = this.renderAtCoordinates(left, top);
      console.log('TOP is: ' + top);
      console.log('LEFT is: ' + left);
      console.log('percent right: ' + coords.percent_right);
      console.log('percent down: ' + coords.percent_down);
      var gb = document.querySelector('.theses-overlay');
      if (gb) {
        board_height = gb.getBoundingClientRect().height;
        board_width = gb.getBoundingClientRect().width;
        var gb2 = document.querySelector('.theses-overlay .gameboard');
        if (coords.percent_right > 15) {}
        if (coords.percent_right < 62) {
          console.log('shifting left: ' + board_width / 6);
          gb2.style.left = '-' + parseInt(board_width / 6) + 'px';
        }
        if (coords.percent_down > 50) {
          console.log('shifting up: ' + board_height / 3);
          gb2.style.top = '+' + parseInt(board_height / 3) + 'px';
        }
      }
      return 0;
    }
  }, {
    key: "renderAtCoordinates",
    value: function renderAtCoordinates(xpos, ypos) {
      this.pushHudUnderOverlay();
      this.visible = true;
      this.rendering_at_coordinates = true;
      var gb = this.mod.getBoardElement();
      if (!gb) {
        return;
      }
      xpos = parseInt(xpos);
      ypos = parseInt(ypos);
      var top = parseInt(gb.getBoundingClientRect().top);
      var left = parseInt(gb.getBoundingClientRect().left);
      var width = parseInt(gb.getBoundingClientRect().width);
      var height = parseInt(gb.getBoundingClientRect().height);
      var current_xpos = parseInt(xpos - left);
      var current_ypos = parseInt(ypos - top);
      var percent_right = parseInt(parseFloat(current_xpos / width) * 100);
      var percent_down = parseInt(parseFloat(current_ypos / height) * 100);
      percent_right -= 12;
      percent_down -= 8;
      if (percent_down < 16) {
        percent_down = 16;
      }
      if (percent_right < 15) {
        percent_right = 15;
      }
      if (percent_right > 62.5) {
        percent_right = 62.5;
      }
      if (percent_down > 63.5) {
        percent_down = 63.5;
      }
      this.render();
      this.rendering_at_coordinates = false;

      // remove status
      var status = document.querySelector('.theses-overlay .status');
      status.style.display = 'none';
      var controls = document.querySelector('.theses-overlay .controls');
      controls.style.display = 'none';
      var gb2 = document.querySelector('.gameboard-clone');
      gb2.classList.remove('zoom-german');
      gb2.classList.remove('zoom-french');
      gb2.classList.remove('zoom-spanish');
      gb2.classList.remove('zoom-italian');
      gb2.classList.remove('zoom-english');
      gb2.classList.remove('zoom-ottoman');
      gb2.style.transform = "translate(-".concat(percent_right, "%, -").concat(percent_down, "%) scaleX(0.7) scaleY(0.7)");
      return {
        percent_right: percent_right,
        percent_down: percent_down
      };
    }
  }, {
    key: "render",
    value: function render() {
      var language_zone = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'german';
      this.pushHudUnderOverlay();

      //
      // if already visible, don't reload
      //
      if (this.visible == true) {
        if (document.querySelector('.theses_overlay')) {
          return;
        }
      }
      this.visible = true;
      this.overlay.show(ThesesTemplate());
      var dw = document.querySelector('.theses-overlay');
      var gb = this.mod.getBoardElement();
      if (!gb) {
        return;
      }
      var gb2 = gb.cloneNode(true);
      gb2.removeAttribute('id');
      gb2.removeAttribute('style');
      gb2.classList.add('gameboard-clone');
      if (language_zone == 'german') {
        gb2.classList.add('zoom-german');
      }
      if (language_zone == 'english') {
        gb2.classList.add('zoom-english');
      }
      if (language_zone == 'french') {
        gb2.classList.add('zoom-french');
      }
      if (language_zone == 'spanish') {
        gb2.classList.add('zoom-spanish');
      }
      if (language_zone == 'italian') {
        gb2.classList.add('zoom-italian');
      }
      if (language_zone == 'ottoman') {
        gb2.classList.add('zoom-ottoman');
      }
      dw.appendChild(gb2);
      $('.gameboard-clone').draggable({});
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      //
      // add tiles
      //
      for (var key in this.mod.spaces) {
        var qs = '.theses-overlay .gameboard .' + key;
        document.querySelector(qs).onclick = function (e) {
          var space_id = e.currentTarget.id;
          if (_this.spaces_onclick_callback != null) {
            _this.spaces_onclick_callback(space_id);
          } else {
            _this.mod.displaySpaceDetailedView(space_id);
          }
        };
      }
      for (var _key in this.mod.navalspaces) {
        var _qs = '.theses-overlay .gameboard .' + _key;
        document.querySelector(_qs).onclick = function (e) {
          var space_id = e.currentTarget.id;
          if (_this.spaces_onclick_callback != null) {
            _this.spaces_onclick_callback(space_id);
          } else {
            _this.mod.displaySpaceDetailedView(space_id);
          }
        };
      }
    }
  }]);
}();
module.exports = ThesesOverlay;